import 'jquery-ui';
import { post } from "jquery";
import Swal from "sweetalert2";
import { BlockPageHelper } from '../Helpers/helpers';
import * as bootstrap from 'bootstrap';
const Genesis = require("../Genesis.js");

export class ISiteMobileDocumentCaptureImagePage {
    private canvas = document.getElementById('canvas') as HTMLCanvasElement;
    private btnSelectCamera = document.getElementById('btnSelectCamera') as HTMLCanvasElement;
    private btnUploadPhoto = document.getElementById('btnUploadPhoto') as HTMLCanvasElement;
    private btnTakePhoto = document.getElementById('btnTakePhoto') as HTMLCanvasElement;
    private btnflipCamera = document.getElementById('btnflipCamera') as HTMLCanvasElement;
    private shortname = document.getElementById('shortname') as HTMLCanvasElement;
    public context = this.canvas.getContext('2d');
    private video = document.querySelector('video');
    private videoStream = new MediaStream();
    private frontCam = true
    private paint: boolean = false;
    public isStoreLocal: boolean = false;

    private clickX: number[] = [];
    private clickY: number[] = [];
    private clickDrag: boolean[] = [];
    public tempCanvas: HTMLCanvasElement = document.createElement('canvas');
    public tempCtx = this.tempCanvas.getContext('2d');

    constructor() {
        let canvas = document.getElementById('canvas') as
            HTMLCanvasElement;

        let context = canvas.getContext("2d");
        if (context != null) {
            context.lineCap = 'round';
            context.lineJoin = 'round';
            context.strokeStyle = 'yellow';
            context.lineWidth = 3;
        }
        canvas.height = window.innerHeight;
        canvas.width = window.innerWidth;
        this.canvas = canvas;
        this.context = context;
        this.canvas.hidden = true;
        this.btnSelectCamera.hidden = true;
        this.btnUploadPhoto.hidden = true;
        this.shortname.hidden = true;

        this.redraw();
        this.createUserEvents();
    }

    public Init() {
        this.LoadCamera();
        $("#btnTakePhoto").click(() => this.takePicture());
        $("#btnflipCamera").click(() => this.flipCamera());
        $("#btnUploadPhoto").click(() => this.capturedUpload());
        $("#btnSelectCamera").click(() => this.showCamera());
        $("#btnUndo").click(() => this.clearCanvas());
        $("#switchHighlight").change(() => this.HighlighChangeEvents());
        $("#btnUndo").hide();
    }

    takePicture = async () => {
        const photo = document.querySelector('img');
        if (this.context !== null && this.video !== null) {
            this.canvas.hidden = false;
            this.context.drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height);
            if (photo !== null) {
            }

            this.tempCanvas.width = this.canvas.width;
            this.tempCanvas.height = this.canvas.height;
            if (this.tempCtx != null) {
                this.tempCtx.drawImage(this.canvas, 0, 0);
            }

            this.video.hidden = true;
            this.btnSelectCamera.hidden = false;
            this.shortname.hidden = false;
            this.btnUploadPhoto.hidden = false;
            this.btnTakePhoto.hidden = true;
            this.btnflipCamera.hidden = true;
            $("#shortname").val("");
        }
    }

    flipCamera = async () => {
        this.videoStream.getTracks().forEach(function (track) {
            track.stop();
        });
        this.frontCam = this.frontCam ? false : true;
        this.LoadCamera();
    }

    capturedUpload = async () => {
        if ($("#shortname").val() == "") {
            Swal.fire({ text: `Please enter a Short Name/Description for the photo` });
        }
        else {
            BlockPageHelper.block();
            if (this.isStoreLocal) {
                const image = this.canvas.toDataURL("image/png");
                const fileData = {
                    name: ($("#shortname").val() as string) + ".png",
                    type: "image/png",
                    size: image.length,
                    content: image 
                };

                let pendingUploads: any[] = JSON.parse(localStorage.getItem("pendingUploads") || "[]");
                pendingUploads.push(fileData);
                localStorage.setItem("pendingUploads", JSON.stringify(pendingUploads));
                const modal = bootstrap.Modal.getInstance(document.getElementById("photoModal")!)
                    || new bootstrap.Modal(document.getElementById("photoModal")!);
                modal.hide();
                const badge = document.getElementById("badgeCount") as HTMLElement;
                if (pendingUploads.length > 0) {
                    badge.style.display = 'inline'; 
                    badge.textContent = pendingUploads.length.toString(); 
                } else {
                    badge.style.display = 'none';
                }
                BlockPageHelper.unblock();
                Swal.fire({ text: `File was uploaded successfully` });
            }
            else {
                var image = this.canvas.toDataURL("image/png");
                var blobBin = atob(image.split(',')[1]);
                var array = [];
                for (var i = 0; i < blobBin.length; i++) {
                    array.push(blobBin.charCodeAt(i));
                }
                var file = new Blob([new Uint8Array(array)], { type: 'image/png' });

                const formData = new FormData();
                formData.append("file", file, ($("#shortname").val() as string) + ".png");
                formData.append("recordId", ($("#recordId").val() as string));
                formData.append("shortname", ($("#shortname").val() as string));
                formData.append("libraryName", ($("#libraryName").val() as string));
            formData.append("isAssetCapture", ($("#isAssetCapture").val() === "True").toString());
            formData.append("secondaryId", ($("#secondaryId").val() as string));


            post({
                    url: Genesis.url('Document/UploadCapturedImage'),
                    data: formData,
                    enctype: 'multipart/form-data',
                    processData: false,
                    contentType: false
                }).then(() => {
                    Swal.fire({ text: `File was uploaded successfully` });
                }).fail(() => {
                    Swal.fire({ text: `Failed to Upload the File` });
                }).catch(() => {
                    Swal.fire({ text: `Failed to Upload the File` });
                }).always(() => {
                    BlockPageHelper.unblock();
                });
            }
        }
    }

    showCamera = async () => {
        this.clearCanvas();
        this.canvas.hidden = true;
        this.btnSelectCamera.hidden = true;
        this.shortname.hidden = true;
        this.btnUploadPhoto.hidden = true;
        if (this.video != null) {
            this.video.hidden = false;
        }
        this.btnTakePhoto.hidden = false;
        this.btnflipCamera.hidden = false;
    }

    private LoadCamera() {
        const constraints = {
            audio: false,
            video: {
                facingMode: this.frontCam ? "environment" : "user"
            }
        };
        navigator.mediaDevices.getUserMedia(constraints)
            .then((mediaStream) => {
                if (this.video !== null) {
                    this.videoStream = mediaStream;
                    this.video.srcObject = mediaStream;
                    this.video.onloadedmetadata = () => {
                        if (this.video !== null) {
                            this.video.play();
                        }
                    }
                };
            })
            .catch((err) => {
                console.error(`${err.name}: ${err.message}`);
            });
    }

    private createUserEvents() {
        let canvas = this.canvas;
        canvas.addEventListener("mousedown", this.pressEventHandler);
        canvas.addEventListener("mousemove", this.dragEventHandler);
        canvas.addEventListener("mouseup", this.releaseEventHandler);
        canvas.addEventListener("mouseout", this.cancelEventHandler);
        canvas.addEventListener("touchstart", this.pressEventHandler);
        canvas.addEventListener("touchmove", this.dragEventHandler);
        canvas.addEventListener("touchend", this.releaseEventHandler);
        canvas.addEventListener("touchcancel", this.cancelEventHandler);
    }


    public RemoveUserEvents() {
        let canvas = this.canvas;
        canvas.removeEventListener("mousedown", this.pressEventHandler);
        canvas.removeEventListener("mousemove", this.dragEventHandler);
        canvas.removeEventListener("mouseup", this.releaseEventHandler);
        canvas.removeEventListener("mouseout", this.cancelEventHandler);
        canvas.removeEventListener("touchstart", this.pressEventHandler);
        canvas.removeEventListener("touchmove", this.dragEventHandler);
        canvas.removeEventListener("touchend", this.releaseEventHandler);
        canvas.removeEventListener("touchcancel", this.cancelEventHandler);
    }

    public HighlighChangeEvents() {
        if ($("#switchHighlight").prop('checked')) {
            this.createUserEvents();
            $("#btnUndo").show();
        }
        else {
            this.RemoveUserEvents();
            $("#btnUndo").hide();
        }
    }

    private redraw() {
        if ($("#switchHighlight").prop('checked')) {
            let clickX = this.clickX;
            let context = this.context;
            let clickDrag = this.clickDrag;
            let clickY = this.clickY;
            if (context != null) {
                context.strokeStyle = 'yellow'
                for (let i = 0; i < clickX.length; ++i) {
                    context.beginPath();
                    if (clickDrag[i] && i) {
                        context.moveTo(clickX[i - 1], clickY[i - 1]);
                    } else {
                        context.moveTo(clickX[i] - 1, clickY[i]);
                    }
                    context.lineTo(clickX[i], clickY[i]);
                    context.stroke();
                }
                context.closePath();
            }
        }
    }

    private addClick(x: number, y: number, dragging: boolean) {
        if ($("#switchHighlight").prop('checked')) {
            this.clickX.push(x);
            this.clickY.push(y);
            this.clickDrag.push(dragging);
        }
    }

    private clearCanvas() {
        if (this.context != null) {
            this.clickX = [];
            this.clickY = [];
            this.clickDrag = [];
            this.context.drawImage(this.tempCanvas, 0, 0)
        }
    }

    private releaseEventHandler = () => {
        this.paint = false;
        this.redraw();
    }

    private cancelEventHandler = () => {
        this.paint = false;
    }


    public resetCamera = () => {
        this.clearCanvas();
        this.canvas.hidden = true;
        this.btnSelectCamera.hidden = true;
        this.shortname.hidden = true;
        this.btnUploadPhoto.hidden = true;
        if (this.video != null) {
            this.video.hidden = false;
        }
        this.btnTakePhoto.hidden = false;
        this.btnflipCamera.hidden = false;
    }

    private pressEventHandler = (e: MouseEvent | TouchEvent) => {
        let mouseX = (e as TouchEvent).changedTouches ?
            (e as TouchEvent).changedTouches[0].pageX :
            (e as MouseEvent).pageX;
        let mouseY = (e as TouchEvent).changedTouches ?
            (e as TouchEvent).changedTouches[0].pageY :
            (e as MouseEvent).pageY;
        mouseX -= this.canvas.getBoundingClientRect().left + window.scrollX;
        mouseY -= this.canvas.getBoundingClientRect().top+ window.scrollY;
        this.paint = true;
        this.addClick(mouseX, mouseY, false);
        this.redraw();
    }

    private dragEventHandler = (e: MouseEvent | TouchEvent) => {
        let mouseX = (e as TouchEvent).changedTouches ?
            (e as TouchEvent).changedTouches[0].pageX :
            (e as MouseEvent).pageX;
        let mouseY = (e as TouchEvent).changedTouches ?
            (e as TouchEvent).changedTouches[0].pageY :
            (e as MouseEvent).pageY;
        mouseX -= this.canvas.getBoundingClientRect().left + window.scrollX;
        mouseY -= this.canvas.getBoundingClientRect().top + window.scrollY;

        if (this.paint) {
            this.addClick(mouseX, mouseY, true);
            this.redraw();
        }
        e.preventDefault();
    }
};